import React, { PropsWithChildren } from 'react';

import { Block } from '@bcp-channels-sharedcomponents-reactjs/core';
import { rem } from '@helpers';

type BaseProps = PropsWithChildren<{
	appearance?: 'primary' | 'secondary';
	style?: React.CSSProperties;
	align?: 'start' | 'center' | 'end';
	innerPadding?: string;
	colorfulBorder?: { visible?: boolean; color?: string };
}>;

export const Base: React.FC<BaseProps> = ({
	children,
	appearance = 'primary',
	style,
	align,
	innerPadding = '1.5rem',
	colorfulBorder = { visible: false },
}) => {
	return (
		<Block style={{ width: '100%' }}>
			{colorfulBorder.visible && (
				<Block
					style={{
						backgroundColor: colorfulBorder.color ? colorfulBorder.color : '#d1005d',
						width: '6px',
						borderRadius: '16px 0 0 16px',
					}}
				/>
			)}
			<Block
				style={{
					backgroundColor: appearance === 'primary' ? '#ffffff' : '#F3F4F6',
					padding: innerPadding,
					borderRadius: colorfulBorder.visible ? '0px 20px 20px 0px' : rem(16),
					alignItems: align,
					width: '100%',
					...style,
				}}
			>
				{children}
			</Block>
		</Block>
	);
};
